import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect, useRef } from "react";

import Image from "../fragments/Image";
import SpecialText from '../fragments/SpecialText';

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function Community({ block }) {
    
    const swiperRef = useRef(null);
    const borderRevealRef = useReveal({ once: true });
    const textRevealRef = useReveal({ once: true });
    const leftMediaRevealRef = useReveal({ once: true });
    const rightMediaRevealRef = useReveal({ once: true });

    const heading_maximum_width = block.heading_maximum_width ? block.heading_maximum_width + 'em' : '30em';

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--community`}>
            <div className={`l-grid c-community`}>
                <div className="l-grid__col c-transition-in" ref={borderRevealRef}>
                    <div className="c-community__hr" />
                </div>
                <div className={'l-grid__col l-grid__col--l-6-12 c-transition-in'} ref={textRevealRef}>
                    
                    <div className="c-community__header">
                        {block.heading && (
                            <h3 className="c-community__heading c-heading c-heading--accent" style={{ maxWidth: heading_maximum_width }}>
                                <SpecialText text={block.heading || 'Community'} />
                            </h3>
                        )}
                        {block.introduction && (
                            <p className="c-community__introduction c-heading" style={{ maxWidth: heading_maximum_width }}>
                                <SpecialText text={block.introduction || ''} />
                            </p>
                        )}
                    </div>
                    <div className="c-community__body">
                        {block.text && (
                            <div className="c-community__text scope-text scope-text--medium" dangerouslySetInnerHTML={{ __html: `<p>${block.text}</p>` }} />
                        )}
                        {block.logos_src && (
                            <div className="c-community__logos" style={{ maxWidth: '26.375rem' }}>
                                <Image 
                                    src={block.logos_src} 
                                    alt={block.logos_alt || ''}
                                    width={block.logos_width || 600}
                                    height={block.logos_height || 400}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className={'l-grid__col l-grid__col--xs-6-12 l-grid__col--m-4-12 l-grid__col--m-push-4-12 l-grid__col--l-5-24 l-grid__col--l-push-1-12'}>
                    {block.left_image_src && (
                        <div className="c-community__image c-community__image--left c-transition-in" ref={leftMediaRevealRef}>
                            <div className="c-parallax" data-speed="0.1">
                                <Image
                                    src={block.left_image_src}
                                    alt={block.left_image_alt || ''}
                                    width={block.left_image_width || 400}
                                    height={block.left_image_height || 400}
                                />
                                {block.left_image_caption && (
                                    <p className="c-community__image__caption c-paragraph" dangerouslySetInnerHTML={{__html: block.left_image_caption}} />
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <div className={'l-grid__col l-grid__col--xs-6-12 l-grid__col--m-4-12 l-grid__col--l-5-24'}>
                    {block.right_image_src && (
                        <div className="c-community__image c-community__image--right c-transition-in" ref={rightMediaRevealRef}>
                            <div className="c-parallax" data-speed="0.1">
                                <Image
                                    src={block.right_image_src}
                                    alt={block.right_image_alt || ''}
                                    width={block.right_image_width || 400}
                                    height={block.right_image_height || 400}
                                />
                                {block.right_image_caption && (
                                    <p className="c-community__image__caption c-paragraph" dangerouslySetInnerHTML={{__html: block.right_image_caption }} />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}